export const typeList = [
  { id: "from_school", name: "From School", color: "#00bcd4" },
  { id: "to_school", name: "To School", color: "#40c4ff" },
  { id: "cca", name: "CCA", color: "#2a9df4" },
];

export const schoolTimeLabel = (type: string) => {
  switch (type) {
    case "ToSchool":
      return "School Start Time";
    case "FromSchool":
      return "School End Time";
    case "Cca":
      return "Cca End Time";

    default:
      break;
  }
};

export const arrivalTimeLabel = (type: string) => {
  switch (type) {
    case "ToSchool":
      return "Bus Arrive by";
    case "FromSchool":
    case "Cca":
      return "Bus Leave by";

    default:
      break;
  }
};
